/** Xuất CSV mở thẳng được bằng Excel. Hàm thuần, có test. */

/** Dấu BOM của UTF-8 — viết bằng MÃ KÝ TỰ để không có ký tự vô hình nào nằm trong mã nguồn. */
const BOM = String.fromCharCode(0xfeff);

/** Bọc nháy kép khi ô có nháy kép, dấu phẩy, chấm phẩy hoặc xuống dòng; nháy kép trong ô nhân đôi. */
export function csvCell(value: string): string {
  return /[",;\n\r]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

/**
 * Bảng → chữ CSV: ngăn bằng dấu phẩy, xuống dòng CRLF, mở đầu bằng BOM — thiếu BOM thì Excel đọc tiếng
 * Việt thành ký tự rác.
 */
export function toCsv(rows: ReadonlyArray<readonly string[]>): string {
  return BOM + rows.map((row) => row.map(csvCell).join(',')).join('\r\n');
}

/** Tải một đoạn chữ xuống máy dưới dạng file (chỉ chạy trong trình duyệt). */
export function downloadTextFile(
  filename: string,
  content: string,
  mime = 'text/csv;charset=utf-8',
): void {
  const url = URL.createObjectURL(new Blob([content], { type: mime }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.append(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
